import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import { FaFacebookF, FaWhatsapp, FaLinkedinIn, FaTwitter } from 'react-icons/fa';
import { GoMail } from 'react-icons/go';
import {
  FacebookShareButton,
  TwitterShareButton,
  LinkedinShareButton,
  WhatsappShareButton,
  EmailShareButton,
} from 'react-share';

import styled from 'styled-components';

const ShareButtons = ({ title, url, lang }) => {
  const data = useStaticQuery(graphql`
    {
      sanityDictionaryGeneral {
        shareThisItem {
          _type
          de
          en
        }
      }
    }
  `);
  return (
    <>
      {data.sanityDictionaryGeneral.shareThisItem.de &&
      data.sanityDictionaryGeneral.shareThisItem.en ? (
        <StyledShareTitle>{data.sanityDictionaryGeneral.shareThisItem[lang]}:</StyledShareTitle>
      ) : (
        ''
      )}
      <StyledButtonContainer>
        <FacebookShareButton url={url} title={title} className="button facebook">
          <span className="icon">
            <FaFacebookF />
          </span>
          <span>Facebook</span>
        </FacebookShareButton>
        <TwitterShareButton url={url} title={title} className="button twitter">
          <span className="icon">
            <FaTwitter />
          </span>
          <span>Twitter</span>
        </TwitterShareButton>
        <LinkedinShareButton url={url} title={title} className="button linkedin">
          <span className="icon">
            <FaLinkedinIn />
          </span>
          <span>LinkedIn</span>
        </LinkedinShareButton>
        <WhatsappShareButton url={url} title={title} className="button whatsapp">
          <span className="icon">
            <FaWhatsapp />
          </span>
          <span>WhatsApp</span>
        </WhatsappShareButton>
        <EmailShareButton url={url} title={title} className="button email">
          <span className="icon">
            <GoMail />
          </span>
          <span>Email</span>
        </EmailShareButton>
      </StyledButtonContainer>
    </>
  );
};

const StyledShareTitle = styled.span`
  text-transform: uppercase;
  font-weight: 400;
  display: flex;
  align-items: center;
  margin-right: 1rem;
`;

const StyledButtonContainer = styled.section`
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  & > .button {
    background-color: ${(props) => props.theme.colors.transparent};
    border-radius: 290486px;
    display: inline-flex;
    justify-content: center;
    margin: 0.5rem 0.25rem;
    padding: calc(0.375em - 1px) 1em !important;
    text-align: center;
    white-space: nowrap;
    cursor: pointer;
    transition: ${(props) => props.theme.transforms.transitionLong};

    & > .icon {
      width: 1.5em;
      height: 1.5em;
      margin-left: calc(-0.375rem - 1px);
      margin-right: 0.1875rem;
      display: inline-flex;
      justify-content: center;
      align-items: center;
    }
  }

  & > .button.facebook {
    color: ${(props) => props.theme.colors.facebook} !important;
    border: 1px solid ${(props) => props.theme.colors.facebook} !important;
    &:hover,
    &:active {
      color: ${(props) => props.theme.colors.white} !important;
      background-color: ${(props) => props.theme.colors.facebook} !important;
    }
  }
  & > .button.twitter {
    color: ${(props) => props.theme.colors.twitter} !important;
    border: 1px solid ${(props) => props.theme.colors.twitter} !important;
    &:hover,
    &:active {
      color: ${(props) => props.theme.colors.white} !important;
      background-color: ${(props) => props.theme.colors.twitter} !important;
    }
  }
  & > .button.linkedin {
    color: ${(props) => props.theme.colors.linkedin} !important;
    border: 1px solid ${(props) => props.theme.colors.linkedin} !important;
    &:hover,
    &:active {
      color: ${(props) => props.theme.colors.white} !important;
      background-color: ${(props) => props.theme.colors.linkedin} !important;
    }
  }
  & > .button.whatsapp {
    color: ${(props) => props.theme.colors.whatsapp} !important;
    border: 1px solid ${(props) => props.theme.colors.whatsapp} !important;
    &:hover,
    &:active {
      color: ${(props) => props.theme.colors.white} !important;
      background-color: ${(props) => props.theme.colors.whatsapp} !important;
    }
  }
  & > .button.email {
    color: ${(props) => props.theme.colors.email} !important;
    border: 1px solid ${(props) => props.theme.colors.email} !important;
    &:hover,
    &:active {
      color: ${(props) => props.theme.colors.white} !important;
      background-color: ${(props) => props.theme.colors.email} !important;
    }
  }
`;

export default ShareButtons;
